import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { AuthorizationPayrollState, AuthorizationPayrollContextActionTypes } from './types';
import { defaultAuthorizationPayrollState } from './defaultState';

const AuthorizationPayrollContext = createContext<Partial<AuthorizationPayrollState>>(defaultAuthorizationPayrollState);
const AuthorizationPayrollDispatchContext = createContext<
  Dispatch<PayloadAction<AuthorizationPayrollContextActionTypes, any>> | undefined
>(undefined);

export { AuthorizationPayrollContext, AuthorizationPayrollDispatchContext };
